import MetafieldsModal from './MetafieldsModal';

export default MetafieldsModal;
